import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Sep 11 2018
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Tier } from '@logio/common-be-fe';
import { Map } from 'immutable';
import { action, observable, runInAction, computed } from 'mobx';
import { TierLayer } from '../../transportLayers/tier/TierLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of tiers.
 */

export var TierStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(TierStore, _BaseStore);

  function TierStore() {
    var _this;

    _classCallCheck(this, TierStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TierStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Tier;
    /** layer containes methods for fletching data */

    _this.tierLayer = new TierLayer();
    /** List of tiers */

    _this.list = Map();
    return _this;
  }
  /**
   * Method sort array using insertion sorting
   * @param tiers - array of tiers in random order
   */


  _createClass(TierStore, [{
    key: "tierSort",
    value: function tierSort(tiers) {
      for (var i = 0; i < tiers.length; i++) {
        var value = tiers[i];
        var j = i - 1;

        for (j; j > -1 && tiers[j].level > value.level; j--) {
          tiers[j + 1] = tiers[j];
        }

        tiers[j + 1] = value;
      }

      return tiers;
    }
    /**
     * @param tiers
     */

  }, {
    key: "updateTiers",
    value: function updateTiers(tiers) {
      var _this2 = this;

      var newlist = Map();
      this.tierSort(tiers).forEach(function (tier) {
        if (tier.id) {
          newlist = newlist.set(tier.id, tier);
        }
      });
      runInAction(function () {
        _this2.list = newlist;
      });
    }
    /**
     * Fletches all Tiers
     * returns a promise with Map of all Tiers
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var _this3 = this;

      return this.tierLayer.findAll().then(function (tiers) {
        _this3.updateTiers(tiers);

        return _this3.list;
      });
    }
    /**
     * Method updates tier using tierLayer.
     * As response gets all existed tiers in random order.
     * @param item -  tier that you want to update
     */

  }, {
    key: "update",
    value: function update(tier) {
      var _this4 = this;

      return this.tierLayer.update(tier).then(function (updatedTiers) {
        _this4.updateTiers(updatedTiers);
      });
    }
    /**
     * Method create new tier using tierLayer.
     * As response gets all tiers in random order.
     * @param item -  new tier that you want to create
     */

  }, {
    key: "create",
    value: function create(tier) {
      var _this5 = this;

      return this.tierLayer.create(tier).then(function (updatedTiers) {
        _this5.updateTiers(updatedTiers);
      });
    }
    /**
     * Method deletes existing tier using tierLayer.
     * As response gets all tiers in random order.
     * @param id -  id of the tierm that you want to delete.
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this6 = this;

      return this.tierLayer.delete(id).then(function (updatedTiers) {
        _this6.updateTiers(updatedTiers);
      });
    }
  }, {
    key: "defaultTier",
    get: function get() {
      return this.list.find(function (tier) {
        return tier.isDefault;
      });
    }
  }, {
    key: "minTier",
    get: function get() {
      return this.list.minBy(function (tier) {
        return tier.level;
      });
    }
  }, {
    key: "maxTier",
    get: function get() {
      return this.list.maxBy(function (tier) {
        return tier.level;
      });
    }
  }]);

  return TierStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], TierStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", void 0)], TierStore.prototype, "updateTiers", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], TierStore.prototype, "delete", null);

__decorate([computed, __metadata("design:type", Tier), __metadata("design:paramtypes", [])], TierStore.prototype, "defaultTier", null);

__decorate([computed, __metadata("design:type", Tier), __metadata("design:paramtypes", [])], TierStore.prototype, "minTier", null);

__decorate([computed, __metadata("design:type", Tier), __metadata("design:paramtypes", [])], TierStore.prototype, "maxTier", null);